import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Image } from "@sparefoot/react-commons";
import TooltipBanner from "components/atoms/TooltipBanner/TooltipBanner";
import "./TopBanner.scss";

export function TopBanner({
	className,
	title,
	content,
	icon,
	tooltipMessage,
	tooltipIcon,
	iconAlt,
	type
}) {
	const [showFees, setShowFees] = useState(false);
	return (
		<div
			className={classnames(
				"top-banner",
				type && `top-banner--${type}`,
				className
			)}
		>
			{icon && (
				<Image
					src={icon}
					className="top-banner__icon"
					alt={iconAlt}
				/>
			)}
			<div className="top-banner__text">
				<span className="top-banner__title">{title}</span>
				<span className="top-banner__content">{content}</span>
			</div>
			{tooltipMessage && tooltipIcon && (
				<TooltipBanner
					triggerId="top-banner-tooltip"
					tooltipContent={tooltipMessage}
					onShowTooltip={() => setShowFees(true)}
					onHideTooltip={() => setShowFees(false)}
					visible={showFees}
					tooltipIcon={
						<Image
							src={tooltipIcon}
							className="tooltip-icon"
							alt="tooltip icon"
						/>
					}
				/>
			)}
		</div>
	);
}

TopBanner.propTypes = {
	className: PropTypes.string,
	content: PropTypes.node,
	icon: PropTypes.string,
	title: PropTypes.string,
	iconAlt: PropTypes.string,
	tooltipIcon: PropTypes.string,
	tooltipMessage: PropTypes.string,
	type: PropTypes.oneOf([
		"general",
		"promo",
		"omi",
		"discount"
	])
};

TopBanner.defaultProps = {
	className: ""
};

export default TopBanner;
